<mat-form-field [fxFlex]="field.customfield4 === '2' || field.customfield4 === '4' ? 50 : 100 " appearance="outline">
    <mat-label>
        {{field.label}} <span *ngIf="isRequired(field.name)" class="required-symbol">*</span>
    </mat-label>

    <mat-select (selectionChange)="onVendorSelectionChange($event.value)" [placeholder]="field.label"
        [formControl]="localFormControl" [multiple]="true" #multiSelect>
        <mat-option *ngFor="let item of optionsList" [value]="item">{{item}}</mat-option>
    </mat-select>

    <ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name) && group.get(field.name).hasError(validation.name)">
            {{validation.message}}
        </mat-error>
    </ng-container>

    <mat-hint [align]="start"
        *ngFor="let validation of field['dynamicFormLabelValidator'];">{{validation.hintMessage}}</mat-hint>
</mat-form-field>